export const TASK_STATUS = {
  INITIAL: 'ยังไม่มีคนรับงาน',
  ACCEPT: 'มีคนรับงานแล้ว',
  IN_PROGRESS: 'กำลังดำเนินการ',
  SUCCESS: 'สำเร็จ',
  FAIL: 'ไม่สำเร็จ',
}
